import { BibliaItemModel } from 'src/app/model/file/model.file';

export function stringifyValue(data: any): string {
  return JSON.stringify(data);
}

export function sortDetailPassengers(listPax: any[]): any[] {
  const currentDate = new Date();
  const adaptedListPax = listPax
    .filter((pax) => !!pax?.estado)
    .map((pax) => {
      const dateToUse = pax.pasajero?.updatedAt || pax.pasajero?.createdAt;
      const createdAt = new Date(dateToUse);
      const diffMs = currentDate.getTime() - createdAt?.getTime();
      const diffDias = diffMs / (1000 * 60 * 60 * 24);

      return {
        ...pax,
        recent: diffDias <= 3
      };
    })
    .sort((paxA, paxB) => {
      const dateA = paxA.pasajero?.updatedAt || paxA.pasajero?.createdAt;
      const dateB = paxB.pasajero?.updatedAt || paxB.pasajero?.createdAt;
      const fechaA = dateA ? new Date(dateA).getTime() : 0;
      const fechaB = dateB ? new Date(dateB).getTime() : 0;

      if (fechaA !== fechaB) return fechaB - fechaA;

      const numA = parseInt(paxA.Pax.replace(/\D/g, ''), 10);
      const numB = parseInt(paxB.Pax.replace(/\D/g, ''), 10);
      return numA - numB;
    });

  return [
    ...adaptedListPax.filter((pax) => pax.Pax.includes('passenger-')),
    ...adaptedListPax.filter((pax) => pax.Pax.includes('tc-'))
  ];
}

export function getAccommodationLabel(row: BibliaItemModel, fallback: string): string {
  if (row?.serviciosAlojamiento != null && row.serviciosAlojamiento?.length > 0) {
    return row.serviciosAlojamiento
      .map((alojamiento) => {
        const nombre = alojamiento.objProvider?.nombre;
        const reserva = alojamiento.numReserva;
        return nombre ? `${nombre}${reserva ? ` - ${reserva}` : ''}` : null;
      })
      .filter(Boolean)
      .join(', \n');
  }

  return fallback;
}

export function getPickUp(row: BibliaItemModel): string {
  return row?.pickUp || getAccommodationLabel(row, 'Sin Alojamiento');
}

export function getDropOff(row: BibliaItemModel): string {
  return row?.dropOff || getAccommodationLabel(row, 'Sin Alojamiento');
}

export function transformPassengersToExport(lstPax: BibliaItemModel['lstPaX'], sourceData: any[]): string {
  if (lstPax == null || lstPax.length === 0) return '';

  return lstPax
    .map((pax: any) => {
      const foundPax = sourceData.find((p: any) => p.passengerId === pax.passengerId);
      const data = foundPax || pax;
      const firstName = data.firstName || data.pasajero?.firstName || '';
      const lastName = data.lastName || data.pasajero?.lastName || '';
      const age = data.age || data.pasajero?.age || 'N/A';
      const gender = data.gender || data.pasajero?.gender ? ` (${data.gender || data.pasajero?.gender})` : '';
      const medicalConditions = data.condicionesMedicas || data.pasajero?.condicionesMedicas
        ? ` [${data.condicionesMedicas || data.pasajero?.condicionesMedicas}]`
        : '';

      return `${firstName} ${lastName} ${age}${gender}${medicalConditions}`.trim();
    })
    .join(', ');
}

export function getFormattedFoodRestrictions(lstPaX: BibliaItemModel['lstPaX']): string {
  if (!lstPaX || lstPaX.length === 0) return '';

  return lstPaX
    .filter((pax: any) => pax?.restriccionesAlimentarias)
    .map((pax: any) => `${pax.firstName} ${pax.lastName} - ${pax.restriccionesAlimentarias}`)
    .join('; ');
}
